import { getFromServerToken, postToServerToken } from './fetch'
import { useState, useContext } from 'react';
import EventContext from "../store/event-context";
import { displayCapnr } from '../components/helperFunctions';

const useActor = () => {
    const [isLoadingActor, setIsLoading] = useState(false);
    const [actorData, setData] = useState({});
    const [actorServerError, setServerError] = useState(null);
    const eventctx = useContext(EventContext);

    const resetActor = () => {
        //console.log("Reset actor data");
        setData({});
        setServerError("");
    }

    const fetchActor = async (capnr) => {
        console.log("Fetching Actor: " + capnr)
        setIsLoading(true)
        const { data, status } = await getFromServerToken(`/events/${eventctx.eventId}/actors/${capnr}`)

        if (status === 404) {
            //console.log(eventctx.event)
            let nrPart = capnr
            if (eventctx.event && eventctx.event.colors.length === 1) {
                const hlpArray = capnr.split(":");
                nrPart = hlpArray[1]; 
            }
         
            setServerError(`Capnummer ${nrPart} niet gevonden. Is de zwemmer aangemeld?`)
            setData({})
        } else if (status !== 200) {
            setServerError(data.detail)
            setData({})
        } else {
            data.displayCapnr = displayCapnr(data.capnr, eventctx.event.colors);
            console.log("actorService - setData: ", data);
            setData(data)
            setServerError("")
        }
        setIsLoading(false)
    }

    const actorStateChange = async (url) => {
        // this one requires no body
        setIsLoading(true)
        console.log("ActorStateChange with url: ", url);
        const { data, status } = await postToServerToken(url, {})

        if (status === 404) {
            setServerError("Wijzing is mislukt, de zwemmer is niet gevonden")
            setData({})
        } else if (status !== 200) {
            setServerError(data.detail)
            setData({})
        } else {
            console.log("Data returned: ", data);
            data.displayCapnr = displayCapnr(data.capnr, eventctx.event.colors);
            setData(data)
            setServerError("")
        }
        setIsLoading(false)
    }

    return { actorData, resetActor, isLoadingActor, actorServerError, fetchActor, actorStateChange };
}

export default useActor
